



























































































import { Vue, Prop, Component } from "vue-property-decorator";

@Component
export default class ReportTableProgress extends Vue {
  @Prop({ required: true })
  private data!: number[];
}
